<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2971 5.76722H7.90094C7.23926 5.76722 6.70286 6.37896 6.70286 7.13358V9.86628V11.2326M10.2971
      5.76722H13.2923C13.954 5.76722 14.4904 6.37896 14.4904 7.13358V13.2822C14.4904 14.0368
      13.954 14.6485 13.2923 14.6485H7.90094C7.23926 14.6485 6.70286 14.0368 6.70286
      13.2822V11.2326M10.2971 5.76722V4.40096V3.71779C10.2971 3.35541 10.1709 3.00787 9.94619
      2.75163C9.72151 2.49539 9.41677 2.35143 9.09902 2.35143L3.70766 2.35134C3.38991 2.35134
      3.08518 2.4953 2.86049 2.75154C2.63581 3.00778 2.50958 3.35532 2.50958 3.71769V9.86628C2.50958
      10.2287 2.63581 10.5762 2.86049 10.8324C3.08518 11.0887 3.38991 11.2326 3.70766 11.2326H4.3067H6.70286"
      stroke="currentColor"
      stroke-width="1.37925"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>